import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import SystemHeader from '../SystemHeader';
import { ComboAPI } from '../../services/feature-api';
import { cdnThumb, downloadImage } from '../../utils/CdnImage';
import { markdownToHtml, videoEmbed } from '../../utils/markdownToHtml';
import GuideButton from '../shared/GuideButton';
import { chenSanPham } from './KienThucSanPhamPage';

// 16 Kiến thức kinh doanh — section "Combo" (bảng combo_san_pham, admin /combo-san-pham). Sau này thêm section khác dưới cùng khuôn.
// Anh Bình chốt 22/10/2026: tab nổi bật trên cùng "Tại sao phải bán combo" (bấm mới mở; nội dung = feature_configs.huong_dan của ô 16,
// admin sửa ngay trên trang Combo sản phẩm). Mỗi combo = 1 KHỐI: tiêu đề (STT + tên + chip "N ảnh") rồi TẤT CẢ ảnh bên dưới,
// tối đa 3 ảnh / hàng, bấm ảnh = phóng to (+ nút tải). Hướng dẫn từng combo: anh soạn xong mới tính cách hiện (trang /combo/:id giữ sẵn).
const XANH = '#1E5A35';
const Icon = ({ name, size = 16, className = '', style }) => <span className={`material-symbols-rounded ${className}`} style={{ fontSize: size, lineHeight: 1, ...style }}>{name}</span>;
const laMux = (v) => /^[A-Za-z0-9]{20,}$/.test(String(v || ''));
const KHUNG = 'rounded-2xl overflow-hidden bg-white border border-black/[.08] shadow-[0_2px_10px_rgba(0,0,0,.06)]';
const tenTep = (ten, i) => `${(ten || 'combo').replace(/[\\/:*?"<>|]+/g, ' ').trim()} ${i + 1}.jpg`;

const ThanhTren = ({ ve, nhan, tieuDe }) => (
  <div className="flex items-center gap-2 px-3 py-2 bg-white border-b border-gray-200 sticky top-0 z-10">
    <button type="button" onClick={ve} className="flex items-center gap-1 px-2 py-1.5 rounded-lg text-xs font-medium bg-[#F0F7F2]" style={{ color: XANH }}>
      <Icon name="arrow_back" size={14} /><span>{nhan}</span>
    </button>
    <h1 className="text-sm font-bold text-gray-900 flex-1 truncate">{tieuDe}</h1>
  </div>
);

// Phóng ảnh toàn màn hình: ◀ ▶ + Tải ảnh này. xem = chỉ số ảnh đang xem (null = đóng)
const PhongAnh = ({ anh, ten, xem, setXem }) => {
  const [dangTai, setDangTai] = useState(false);
  if (xem === null || !anh?.length) return null;
  const tai = async () => {
    setDangTai(true);
    try { await downloadImage(anh[xem], tenTep(ten, xem)); } catch { window.open(anh[xem], '_blank'); }
    setDangTai(false);
  };
  return (
    <div className="fixed inset-0 z-50 bg-black/95 flex flex-col" onClick={() => setXem(null)}>
      <div className="flex items-center justify-between px-3 py-2 text-white">
        <span className="text-[13px] truncate pr-2">{ten} · {xem + 1}/{anh.length}</span>
        <button type="button" onClick={() => setXem(null)} className="shrink-0 px-3 py-1.5 rounded-full bg-white text-black text-[13px] font-bold">Đóng</button>
      </div>
      <div className="flex-1 flex items-center justify-center overflow-hidden" onClick={(e) => e.stopPropagation()}>
        <img src={anh[xem]} alt="" className="max-w-full max-h-full object-contain" />
      </div>
      <div className="flex items-center justify-between px-4 py-3" onClick={(e) => e.stopPropagation()}>
        <button type="button" onClick={() => setXem((xem - 1 + anh.length) % anh.length)} className="w-10 h-10 rounded-full bg-white/15 text-white flex items-center justify-center"><Icon name="chevron_left" size={22} /></button>
        <button type="button" onClick={tai} disabled={dangTai} className="px-4 h-10 rounded-full bg-white text-[13px] font-bold flex items-center gap-1 disabled:opacity-50" style={{ color: XANH }}><Icon name={dangTai ? 'hourglass_top' : 'download'} size={16} />{dangTai ? 'Đang tải…' : 'Tải ảnh này'}</button>
        <button type="button" onClick={() => setXem((xem + 1) % anh.length)} className="w-10 h-10 rounded-full bg-white/15 text-white flex items-center justify-center"><Icon name="chevron_right" size={22} /></button>
      </div>
    </div>
  );
};

// 1 khối combo: tiêu đề xanh (STT · tên · N ảnh) + lưới ảnh ≤ 3/hàng (1 ảnh = full, 2 ảnh = 2 cột)
const KhoiCombo = ({ c, moAnh }) => {
  const cot = Math.min(c.anh.length, 3);
  return (
    <section className={KHUNG}>
      <div className="flex items-center gap-2 px-3 py-2.5 text-white" style={{ background: XANH }}>
        {c.stt > 0 && <span className="shrink-0 w-7 h-7 rounded-full bg-white flex items-center justify-center text-[14px] font-black" style={{ color: XANH }}>{c.stt}</span>}
        <h3 className="flex-1 text-[15px] font-extrabold leading-tight">{c.tieu_de}</h3>
        <span className="shrink-0 px-2 py-0.5 rounded-full bg-white/20 text-[11px] font-bold">{c.anh.length} ảnh</span>
      </div>
      <div className={`grid gap-1.5 p-1.5 ${cot === 1 ? 'grid-cols-1' : cot === 2 ? 'grid-cols-2' : 'grid-cols-3'}`}>
        {c.anh.map((u, i) => (
          <button key={u + i} type="button" onClick={() => moAnh(i)} className="aspect-[4/5] rounded-xl overflow-hidden bg-gray-100 border border-black/[.06] active:scale-[.97] transition-transform">
            <img src={cot === 1 ? u : cdnThumb(u)} alt={`${c.tieu_de} ${i + 1}`} loading="lazy" className="w-full h-full object-cover" />
          </button>
        ))}
      </div>
    </section>
  );
};

const KienThucKinhDoanhPage = ({ accessToken, userInfo, onLogout, totalPoints, onRefreshPoints }) => {
  const navigate = useNavigate();
  const [ds, setDs] = useState(null);
  const [xem, setXem] = useState(null); // { c, i }
  useEffect(() => { if (accessToken) ComboAPI.list(accessToken).then((r) => setDs(r.success && Array.isArray(r.data) ? r.data : [])); }, [accessToken]);
  return (
    <div className="min-h-screen bg-[#F4F6F5]">
      <SystemHeader userInfo={userInfo} onLogout={onLogout} totalPoints={totalPoints} pageTitle="Kiến thức kinh doanh" onRefreshPoints={onRefreshPoints} />
      <ThanhTren ve={() => navigate('/dashboard')} nhan="Quay lại" tieuDe="16. Kiến thức kinh doanh" />
      <div className="max-w-md mx-auto p-3 space-y-3">
        <GuideButton slug="huong-dan-combo" nhan="Tại sao phải bán combo?" noiBat />
        <h2 className="text-[20px] font-black text-gray-900 leading-tight px-0.5">Combo</h2>
        {ds && !ds.length && <p className="text-center text-gray-500 text-[13px] py-8">Chưa có combo.</p>}
        {ds && ds.map((c) => <KhoiCombo key={c.id} c={c} moAnh={(i) => setXem({ c, i })} />)}
      </div>
      {xem && <PhongAnh anh={xem.c.anh} ten={xem.c.tieu_de} xem={xem.i} setXem={(v) => setXem(v === null ? null : { c: xem.c, i: typeof v === 'function' ? v(xem.i) : v })} />}
    </div>
  );
};

// Chi tiết 1 combo (chưa có đường vào từ danh sách — chờ anh soạn hướng dẫn rồi chốt cách hiện): ảnh + nút tải → video nếu có → hướng dẫn
export const ComboChiTietPage = ({ accessToken, userInfo, onLogout, totalPoints, onRefreshPoints }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [c, setC] = useState(null);
  const [loi, setLoi] = useState('');
  const [xem, setXem] = useState(null);
  const [dangTai, setDangTai] = useState('');
  useEffect(() => { if (accessToken && id) ComboAPI.chiTiet(accessToken, id).then((r) => (r.success && r.data ? setC(r.data) : setLoi('Không mở được combo này'))); }, [accessToken, id]);

  const tai = async (url, i) => {
    setDangTai(url);
    try { await downloadImage(url, tenTep(c.tieu_de, i)); } catch { window.open(url, '_blank'); }
    setDangTai('');
  };
  const nhung = c?.video && !laMux(c.video) ? videoEmbed(c.video) : null;

  return (
    <div className="min-h-screen bg-[#F4F6F5]">
      <SystemHeader userInfo={userInfo} onLogout={onLogout} totalPoints={totalPoints} pageTitle="Combo" onRefreshPoints={onRefreshPoints} />
      <ThanhTren ve={() => navigate('/kien-thuc-kinh-doanh')} nhan="Combo" tieuDe={c ? (c.stt > 0 ? `${c.stt}. ${c.tieu_de}` : c.tieu_de) : ''} />
      {loi && <div className="m-3 p-3 rounded-xl bg-red-50 text-red-700 text-sm">{loi}</div>}
      {c && (
        <div className="max-w-md mx-auto p-3 space-y-3">
          {c.anh.map((u, i) => (
            <div key={u + i} className={KHUNG}>
              <button type="button" onClick={() => setXem(i)} className="block w-full bg-gray-100">
                <img src={u} alt="" loading={i ? 'lazy' : 'eager'} className="w-full h-auto block" />
              </button>
              <button type="button" onClick={() => tai(u, i)} disabled={!!dangTai}
                      className="w-full h-11 flex items-center justify-center gap-1.5 text-[13.5px] font-bold text-white disabled:opacity-60" style={{ background: XANH }}>
                <Icon name={dangTai === u ? 'hourglass_top' : 'download'} size={18} />{dangTai === u ? 'Đang tải…' : c.anh.length > 1 ? `Tải ảnh ${i + 1}` : 'Tải ảnh'}
              </button>
            </div>
          ))}

          {c.video && (
            <div className={KHUNG}>
              {laMux(c.video) ? (
                <mux-player playback-id={c.video} stream-type="on-demand" metadata-video-title={c.tieu_de} metadata-viewer-user-id={userInfo?.id || ''} accent-color={XANH} playsinline="" style={{ width: '100%', maxHeight: '70vh', display: 'block' }} />
              ) : nhung ? (
                <div className="relative bg-black" style={{ paddingBottom: '56.25%' }}><iframe src={nhung} title="video" className="absolute inset-0 w-full h-full border-0" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen /></div>
              ) : <a href={c.video} target="_blank" rel="noreferrer" className="block px-4 py-3 text-[13px] underline" style={{ color: XANH }}>Mở video</a>}
            </div>
          )}

          {c.huong_dan && (
            <div className={`${KHUNG} px-4 py-3 huong-dan markdown-content text-[13.5px] text-gray-800 leading-relaxed`} dangerouslySetInnerHTML={{ __html: chenSanPham(markdownToHtml(c.huong_dan), c.san_pham || []) }} />
          )}
        </div>
      )}
      {c && <PhongAnh anh={c.anh} ten={c.tieu_de} xem={xem} setXem={setXem} />}
    </div>
  );
};

export default KienThucKinhDoanhPage;
